import { TrafficNode } from './trafficNode';
import { Location } from '../location';
import { TRAFFICNODE_TYPE } from '../../enums/model.enums';
import { HourlyWeather } from '../weather/hourlyWeather';
import { Line } from '../line';
/**
 * class {ContextAwareTrafficNode}
 * should be used to display trafficNode related information extended with distance information to the current point
 * @extends {TrafficNode}
 */
export class ContextAwareTrafficNode extends TrafficNode {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param name
     * @param city
     * @param type
     * @param location
     * @param weather
     * @param distance
     * @param servicingLines
     */
    constructor(id, name, city, type, location, weather, distance, servingLines, metaData) {
        super(id, name, city, type, location, weather, servingLines, metaData);
        this._distance = distance;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {ContextAwareTrafficNode}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.name = values.name || '';
        sanitizedValues.city = values.city || '';
        sanitizedValues.type = values.type !== undefined ? values.type : TRAFFICNODE_TYPE.ANY;
        sanitizedValues.location = values.location ? Location.factory(values.location) : Location.factory({});
        sanitizedValues.weather = [];
        if (values.weather) {
            for (const weather of values.weather) {
                sanitizedValues.weather.push(HourlyWeather.factory(weather));
            }
        }
        sanitizedValues.distance = values.distance !== undefined ? values.distance : 0;
        sanitizedValues.servingLines = [];
        if (values.servingLines) {
            for (const servingLine of values.servingLines) {
                sanitizedValues.servingLines.push(Line.factory(servingLine));
            }
        }
        sanitizedValues.metaData = values.metaData !== undefined ? values.metaData : {};
        return new ContextAwareTrafficNode(sanitizedValues.id, sanitizedValues.name, sanitizedValues.city, sanitizedValues.type, sanitizedValues.location, sanitizedValues.weather, sanitizedValues.distance, sanitizedValues.servingLines, sanitizedValues.metaData);
    }
    /**
     * gets the distance to a reference node in meters
     * @returns {number}
     */
    get distance() {
        return this._distance;
    }
    /**
     * sets the distance to a reference node in meters
     * @param value
     */
    set distance(value) {
        this._distance = value;
    }
}
//# sourceMappingURL=contextAwareTrafficNode.js.map